/* ========================================
   COLLECTION - native Shopify filters via AJAX
   Syncs with Search & Discovery app. Smooth, no full reload.
   ======================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-collection]');
  if (!root) return;

  var form = root.querySelector('[data-filter-form]');
  var results = root.querySelector('[data-collection-results]');
  if (!form || !results) return;

  var sectionId = form.getAttribute('data-section-id');
  var collectionUrl = form.getAttribute('data-collection-url');
  var resultCount = root.querySelector('[data-result-count]');
  var debounceTimer = null;
  var currentSort = null;

  // Read current sort from URL
  var initialParams = new URLSearchParams(window.location.search);
  currentSort = initialParams.get('sort_by') || null;

  // ---------- Build URL from form state ----------
  function buildParams() {
    var params = new URLSearchParams();
    // Checkboxes (list filters)
    form.querySelectorAll('input[type="checkbox"][data-filter-input]:checked').forEach(function (cb) {
      params.append(cb.name, cb.value);
    });
    // Price range
    var priceInput = form.querySelector('[data-price-input]');
    if (priceInput) {
      var max = parseInt(priceInput.getAttribute('max'), 10);
      var val = parseInt(priceInput.value, 10);
      if (val < max) params.set(priceInput.name, val);
    }
    // Sort
    if (currentSort) params.set('sort_by', currentSort);
    return params;
  }

  // ---------- AJAX fetch + swap ----------
  function fetchAndRender(pushUrl) {
    var params = buildParams();
    var qs = params.toString();
    var fetchUrl = collectionUrl + '?section_id=' + sectionId + (qs ? '&' + qs : '');

    results.classList.add('is-loading');

    fetch(fetchUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newResults = doc.querySelector('[data-collection-results]');
        var newForm = doc.querySelector('[data-filter-form]');
        var newCount = doc.querySelector('[data-result-count]');

        if (newResults) results.innerHTML = newResults.innerHTML;
        if (newCount && resultCount) resultCount.textContent = newCount.textContent;

        // Update filter badges + active states from fresh markup
        if (newForm) syncFilterUI(newForm);

        // Update browser URL (shareable / back button)
        var displayUrl = collectionUrl + (qs ? '?' + qs : '');
        window.history.replaceState({ filtered: true }, '', displayUrl);

        results.classList.remove('is-loading');
        bindDynamic();
      })
      .catch(function () {
        results.classList.remove('is-loading');
        // Fallback: hard navigate
        var qs2 = buildParams().toString();
        window.location.href = collectionUrl + (qs2 ? '?' + qs2 : '');
      });
  }

  // ---------- Sync filter button badges/counts after fetch ----------
  function syncFilterUI(newForm) {
    var newDropdowns = newForm.querySelectorAll('[data-filter-group]');
    newDropdowns.forEach(function (nd) {
      var group = nd.getAttribute('data-filter-group');
      if (group === 'sort') return;
      var cur = form.querySelector('[data-filter-group="' + group + '"]');
      if (!cur) return;
      var newBtn = nd.querySelector('[data-dropdown-toggle]');
      var curBtn = cur.querySelector('[data-dropdown-toggle]');
      if (newBtn && curBtn) {
        var newCount = newBtn.querySelector('.collection__dropdown-count');
        var curCount = curBtn.querySelector('.collection__dropdown-count');
        if (newCount) {
          if (curCount) curCount.textContent = newCount.textContent;
          else curBtn.querySelector('span').insertAdjacentHTML('afterend', newCount.outerHTML);
          curBtn.classList.add('is-active');
        } else {
          if (curCount) curCount.remove();
          curBtn.classList.remove('is-active');
        }
      }
    });

    // Clear button visibility
    var anyChecked = form.querySelectorAll('input[type="checkbox"]:checked').length > 0;
    var priceInput = form.querySelector('[data-price-input]');
    var priceActive = priceInput && parseInt(priceInput.value, 10) < parseInt(priceInput.getAttribute('max'), 10);
    var clearBtn = form.querySelector('[data-filter-clear]');
    if (clearBtn) clearBtn.hidden = !anyChecked && !priceActive;
  }

  function scheduleFetch(immediate) {
    clearTimeout(debounceTimer);
    if (immediate) { fetchAndRender(true); return; }
    debounceTimer = setTimeout(function () { fetchAndRender(true); }, 150);
  }

  // ---------- Dropdown toggle ----------
  function bindDropdowns() {
    var dropdowns = Array.prototype.slice.call(form.querySelectorAll('[data-dropdown]'));
    dropdowns.forEach(function (dd) {
      var toggle = dd.querySelector('[data-dropdown-toggle]');
      if (!toggle || toggle._bound) return;
      toggle._bound = true;
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = dd.classList.contains('is-open');
        dropdowns.forEach(function (o) { o.classList.remove('is-open'); });
        if (!isOpen) dd.classList.add('is-open');
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) {
      form.querySelectorAll('[data-dropdown]').forEach(function (o) { o.classList.remove('is-open'); });
    }
  });

  // ---------- Bind filter inputs (checkbox + price) ----------
  function bindDynamic() {
    // Checkboxes
    form.querySelectorAll('input[type="checkbox"][data-filter-input]').forEach(function (cb) {
      if (cb._bound) return;
      cb._bound = true;
      cb.addEventListener('change', function () {
        var label = cb.closest('.collection__chip');
        if (label) label.classList.toggle('is-active', cb.checked);
        scheduleFetch(true);
      });
    });

    // Price slider
    var priceInput = form.querySelector('[data-price-input]');
    var priceCurrent = form.querySelector('[data-price-current]');
    if (priceInput && !priceInput._bound) {
      priceInput._bound = true;
      priceInput.addEventListener('input', function () {
        if (priceCurrent) priceCurrent.textContent = formatMoney(parseInt(priceInput.value, 10));
      });
      priceInput.addEventListener('change', function () { scheduleFetch(false); });
    }

    bindDropdowns();
  }

  function formatMoney(amount) {
    if (window.SYNC && window.SYNC.formatMoneyShop) return window.SYNC.formatMoneyShop(amount);
    return '$' + (amount / 100).toFixed(2);
  }

  // ---------- Sort (delegated, survives swaps) ----------
  form.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-sort]');
    if (!opt) return;
    currentSort = opt.getAttribute('data-sort');
    form.querySelectorAll('[data-sort]').forEach(function (o) { o.classList.remove('is-active'); });
    opt.classList.add('is-active');
    var label = form.querySelector('[data-sort-label]');
    if (label) label.textContent = 'Sort: ' + opt.textContent.trim();
    var dd = opt.closest('[data-dropdown]');
    if (dd) dd.classList.remove('is-open');
    scheduleFetch(true);
  });

  // ---------- Clear all ----------
  var clearBtn = form.querySelector('[data-filter-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        cb.checked = false;
        var label = cb.closest('.collection__chip');
        if (label) label.classList.remove('is-active');
      });
      var priceInput = form.querySelector('[data-price-input]');
      var priceCurrent = form.querySelector('[data-price-current]');
      if (priceInput) {
        priceInput.value = priceInput.getAttribute('max');
        if (priceCurrent) priceCurrent.textContent = formatMoney(parseInt(priceInput.value, 10));
      }
      currentSort = null;
      fetchAndRender(true);
    });
  }

  // ---------- Mobile filter drawer ----------
  var mobileBtn = root.querySelector('[data-mobile-filter-open]');
  function closeFilters() {
    root.classList.remove('filters-open');
    document.body.classList.remove('collection-filters-locked');
  }
  function openFilters() {
    root.classList.add('filters-open');
    document.body.classList.add('collection-filters-locked');
  }
  if (mobileBtn) {
    mobileBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (root.classList.contains('filters-open')) closeFilters();
      else openFilters();
    });
  }
  // Close when tapping the backdrop (anywhere outside the drawer panel while open)
  document.addEventListener('click', function (e) {
    if (!root.classList.contains('filters-open')) return;
    if (window.innerWidth >= 768) return;
    var panel = root.querySelector('[data-filter-form]');
    if (panel && !panel.contains(e.target) && !mobileBtn.contains(e.target)) {
      closeFilters();
    }
  });
  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('filters-open')) closeFilters();
  });

  // ---------- View switch (Models / Items image toggle) ----------
  var viewSwitch = root.querySelector('[data-view-switch]');
  if (viewSwitch) {
    var opts = Array.prototype.slice.call(viewSwitch.querySelectorAll('[data-view-mode]'));
    function setView(mode) {
      root.setAttribute('data-view', mode);
      opts.forEach(function (o) {
        var on = o.getAttribute('data-view-mode') === mode;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      try { localStorage.setItem('sync:view-mode', mode); } catch (e) {}
    }
    opts.forEach(function (o) {
      o.addEventListener('click', function () { setView(o.getAttribute('data-view-mode')); });
    });
    var saved = 'models';
    try { saved = localStorage.getItem('sync:view-mode') || 'models'; } catch (e) {}
    setView(saved);
  }

  bindDynamic();
  bindDropdowns();
})();
